// // Facebook SDK ინიციალიზაცია და OAuth ფუნქციები email

// Facebook User Interface
export interface FacebookUser {
  id: string;
  name: string;
  email?: string;
  picture?: {
    data: {
      url: string;
    };
  };
}

// Facebook SDK დეკლარაცია TypeScript-ისთვის
declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: {
      init: (params: {
        appId: string;
        cookie: boolean;
        xfbml: boolean;
        version: string;
      }) => void;
      login: (
        callback: (response: {
          authResponse: {
            accessToken: string;
            userID: string;
            expiresIn: number;
          } | null;
          status: string;
        }) => void,
        options: { scope: string }
      ) => void;
      logout: (callback: () => void) => void;
      api: (
        path: string,
        params: { fields: string },
        callback: (response: FacebookUser) => void
      ) => void;
      getLoginStatus: (
        callback: (response: {
          status: string;
          authResponse: {
            accessToken: string;
            userID: string;
          } | null;
        }) => void
      ) => void;
    };
  }
}

// Facebook App ID (შენი App ID-დან)
const FACEBOOK_APP_ID = '635040739392559';

// SDK ინიციალიზაციის სტატუსი
let isFacebookSDKInitialized = false;

/**
 * Facebook SDK-ის ჩატვირთვა და ინიციალიზაცია
 */
export const initializeFacebookSDK = (): Promise<void> => {
  return new Promise((resolve) => {
    // თუ უკვე ინიციალიზებულია, დავაბრუნოთ resolve
    if (isFacebookSDKInitialized) {
      resolve();
      return;
    }

    // Facebook SDK-ის ასინქრონული ინიციალიზაცია
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: FACEBOOK_APP_ID,
        cookie: true, // cookies-ების გამოყენება სესიის შესანახად
        xfbml: true, // Facebook Social Plugins-ის პარსინგი
        version: 'v21.0', // Facebook API ვერსია
      });

      isFacebookSDKInitialized = true;
      // console.log('✅ Facebook SDK initialized');
      resolve();
    };

    // SDK-ის სკრიპტის ჩატვირთვა
    if (!document.getElementById('facebook-jssdk')) {
      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.src = 'https://connect.facebook.net/ka_GE/sdk.js'; // ქართული ენა
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode?.insertBefore(script, firstScript);
    }
  });
};

/**
 * Facebook-ით ავტორიზაცია
 * @returns Promise<string> - Facebook Access Token
 */
export const loginWithFacebook = async (): Promise<string | null> => {
  try {
    // ჯერ დავრწმუნდეთ რომ SDK ინიციალიზებულია
    await initializeFacebookSDK();

    return new Promise((resolve) => {
      window.FB.login(
        (response) => {
          if (response.authResponse) {
            console.log('✅ Facebook login successful');
            console.log('Access Token:', response.authResponse.accessToken);
            resolve(response.authResponse.accessToken);
          } else {
            // console.log('❌ Facebook login cancelled');
            resolve(null);
          }
        },
        { scope: 'public_profile' } // permissions
      );
    });
  } catch (error) {
    console.error('Facebook login error:', error);
    return null;
  }
};

/**
 * Facebook მომხმარებლის მონაცემების მიღება
 * @returns Promise<FacebookUser | null>
 */
export const getFacebookUserData = async (): Promise<FacebookUser | null> => {
  try {
    await initializeFacebookSDK();

    return new Promise((resolve) => {
      window.FB.api(
        '/me',
        { fields: 'id,name,picture.width(200).height(200)' },
        (response: FacebookUser) => {
          if (response && !('error' in response)) {
            console.log('✅ Facebook user data received:', response);
            resolve(response);
          } else {
            console.error('❌ Error fetching Facebook user data');
            resolve(null);
          }
        }
      );
    });
  } catch (error) {
    console.error('Error getting Facebook user data:', error);
    return null;
  }
};

/**
 * Facebook-იდან გასვლა
 */
export const logoutFacebook = async (): Promise<boolean> => {
  try {
    await initializeFacebookSDK();

    return new Promise((resolve) => {
      window.FB.logout(() => {
        console.log('✅ Facebook logout successful');
        // ლოკალური მონაცემების გასუფთავება
        localStorage.removeItem('user');
        localStorage.removeItem('facebookAccessToken');
        resolve(true);
      });
    });
  } catch (error) {
    console.error('Facebook logout error:', error);
    return false;
  }
};

/**
 * მიმდინარე Facebook სესიის შემოწმება
 */
export const checkFacebookLoginStatus = async (): Promise<{
  isLoggedIn: boolean;
  accessToken?: string;
  userID?: string;
}> => {
  try {
    await initializeFacebookSDK();

    return new Promise((resolve) => {
      window.FB.getLoginStatus((response) => {
        if (response.status === 'connected' && response.authResponse) {
          resolve({
            isLoggedIn: true,
            accessToken: response.authResponse.accessToken,
            userID: response.authResponse.userID,
          });
        } else {
          resolve({ isLoggedIn: false });
        }
      });
    });
  } catch (error) {
    console.error('Error checking Facebook login status:', error);
    return { isLoggedIn: false };
  }
};

/**
 * Facebook Access Token-ის შენახვა localStorage-ში
 */
export const saveFacebookToken = (token: string): void => {
  localStorage.setItem('facebookAccessToken', token);
};

/**
 * Facebook Access Token-ის წაკითხვა localStorage-დან
 */
export const getFacebookToken = (): string | null => {
  return localStorage.getItem('facebookAccessToken');
};








////////////////////// script
// Facebook SDK ინიციალიზაცია და OAuth ფუნქციები

// Facebook User Interface
// export interface FacebookUser {
//   id: string;
//   name: string;
//   email?: string;
//   picture?: {
//     data: {
//       url: string;
//     };
//   };
// }

// // Facebook SDK დეკლარაცია TypeScript-ისთვის
// declare global {
//   interface Window {
//     fbAsyncInit: () => void;
//     FB: {
//       init: (params: {
//         appId: string;
//         cookie: boolean;
//         xfbml: boolean;
//         version: string;
//       }) => void;
//       login: (
//         callback: (response: {
//           authResponse: {
//             accessToken: string;
//             userID: string;
//             expiresIn: number;
//           } | null;
//           status: string;
//         }) => void,
//         options: { 
//           scope: string;
//           return_scopes?: boolean;
//           auth_type?: string;
//         }
//       ) => void;
//       logout: (callback: () => void) => void;
//       api: (
//         path: string,
//         params: { fields: string },
//         callback: (response: FacebookUser) => void
//       ) => void;
//       getLoginStatus: (
//         callback: (response: {
//           status: string;
//           authResponse: {
//             accessToken: string;
//             userID: string;
//           } | null;
//         }) => void
//       ) => void;
//     };
//   }
// }

// // Facebook App ID (შენი App ID-დან)
// const FACEBOOK_APP_ID = '635040739392559';

// // SDK ინიციალიზაციის სტატუსი
// let isFacebookSDKInitialized = false;

// /**
//  * Facebook SDK-ის ჩატვირთვა და ინიციალიზაცია
//  */
// export const initializeFacebookSDK = (): Promise<void> => {
//   return new Promise((resolve, reject) => {
//     // თუ უკვე ინიციალიზებულია და FB object არსებობს
//     if (isFacebookSDKInitialized && typeof window.FB !== 'undefined') {
//       console.log('✅ SDK already initialized');
//       resolve();
//       return;
//     }

//     // Timeout - თუ 10 წამში არ ჩაიტვირთა
//     const timeout = setTimeout(() => {
//       reject(new Error('Facebook SDK failed to load within 10 seconds'));
//     }, 10000);

//     window.fbAsyncInit = function () {
//       window.FB.init({
//         appId: FACEBOOK_APP_ID,
//         cookie: true,
//         xfbml: true,
//         version: 'v21.0',
//       });

//       isFacebookSDKInitialized = true;
//       clearTimeout(timeout);
//       console.log('✅ Facebook SDK initialized');
//       console.log('App ID:', FACEBOOK_APP_ID);
//       console.log('Current URL:', window.location.href);
//       resolve();
//     };

//     // თუ script უკვე არსებობს და FB ობიექტი უკვე არსებობს
//     if (document.getElementById('facebook-jssdk')) {
//       if (typeof window.FB !== 'undefined') {
//         // FB object უკვე არსებობს - SDK ჩატვირთულია
//         console.log('✅ FB object already exists, SDK ready');
//         isFacebookSDKInitialized = true;
//         clearTimeout(timeout);
//         resolve();
//         return;
//       } else {
//         // Script არსებობს მაგრამ FB object არა - ველოდებით fbAsyncInit-ს
//         console.log('⏳ Facebook SDK script already exists, waiting for init...');
//       }
//     } else {
//       // SDK-ის სკრიპტის ჩატვირთვა
//       const script = document.createElement('script');
//       script.id = 'facebook-jssdk';
//       script.src = 'https://connect.facebook.net/ka_GE/sdk.js';
//       script.async = true;
//       script.defer = true;
//       script.crossOrigin = 'anonymous';
      
//       script.onerror = () => {
//         clearTimeout(timeout);
//         reject(new Error('Failed to load Facebook SDK script'));
//       };
      
//       const firstScript = document.getElementsByTagName('script')[0];
//       firstScript.parentNode?.insertBefore(script, firstScript);
//     }
//   });
// };

// /**
//  * Facebook-ით ავტორიზაცია
//  * @returns Promise<string> - Facebook Access Token
//  */
// export const loginWithFacebook = async (): Promise<string | null> => {
//   try {
//     // ჯერ ვამოწმებთ SDK სტატუსს
//     await initializeFacebookSDK();
    
//     console.log('🔍 Checking if FB SDK is ready...');
//     console.log('FB object exists:', typeof window.FB !== 'undefined');
    
//     // ვამოწმებთ მიმდინარე Login Status-ს
//     return new Promise((resolve) => {
//       window.FB.getLoginStatus((statusResponse) => {
//         console.log('🔍 Current Login Status BEFORE login:', statusResponse);
        
//         // ახლა ვიწყებთ login-ს
//         window.FB.login(
//           (response) => {
//             console.log('🔍 Full Facebook Response:', response);
            
//             if (response.authResponse) {
//               console.log('✅ Facebook login successful');
//               console.log('Access Token:', response.authResponse.accessToken);
//               resolve(response.authResponse.accessToken);
//             } else {
//               console.log('❌ Facebook login cancelled');
//               console.log('Response status:', response.status);
//               resolve(null);
//             }
//           },
//           { 
//             scope: 'public_profile,email',
//             return_scopes: true,  // ← დაამატე ეს
//             auth_type: 'rerequest'  // ← და ეს
//           }
//         );
//       });
//     });
//   } catch (error) {
//     console.error('Facebook login error:', error);
//     return null;
//   }
// };

// /**
//  * Facebook მომხმარებლის მონაცემების მიღება
//  * @returns Promise<FacebookUser | null>
//  */
// export const getFacebookUserData = async (): Promise<FacebookUser | null> => {
//   try {
//     await initializeFacebookSDK();

//     return new Promise((resolve) => {
//       window.FB.api(
//         '/me',
//         { fields: 'id,name,email,picture.width(200).height(200)' },
//         (response: FacebookUser) => {
//           if (response && !('error' in response)) {
//             console.log('✅ Facebook user data received:', response);
//             resolve(response);
//           } else {
//             console.error('❌ Error fetching Facebook user data');
//             resolve(null);
//           }
//         }
//       );
//     });
//   } catch (error) {
//     console.error('Error getting Facebook user data:', error);
//     return null;
//   }
// };

// /**
//  * Facebook-იდან გასვლა
//  */
// export const logoutFacebook = async (): Promise<boolean> => {
//   try {
//     await initializeFacebookSDK();

//     return new Promise((resolve) => {
//       window.FB.logout(() => {
//         console.log('✅ Facebook logout successful');
//         // ლოკალური მონაცემების გასუფთავება
//         localStorage.removeItem('user');
//         localStorage.removeItem('facebookAccessToken');
//         resolve(true);
//       });
//     });
//   } catch (error) {
//     console.error('Facebook logout error:', error);
//     return false;
//   }
// };

// /**
//  * მიმდინარე Facebook სესიის შემოწმება
//  */
// export const checkFacebookLoginStatus = async (): Promise<{
//   isLoggedIn: boolean;
//   accessToken?: string;
//   userID?: string;
// }> => {
//   try {
//     await initializeFacebookSDK();

//     return new Promise((resolve) => {
//       window.FB.getLoginStatus((response) => {
//         if (response.status === 'connected' && response.authResponse) {
//           resolve({
//             isLoggedIn: true,
//             accessToken: response.authResponse.accessToken,
//             userID: response.authResponse.userID,
//           });
//         } else {
//           resolve({ isLoggedIn: false });
//         }
//       });
//     });
//   } catch (error) {
//     console.error('Error checking Facebook login status:', error);
//     return { isLoggedIn: false };
//   }
// };

// /**
//  * Facebook Access Token-ის შენახვა localStorage-ში
//  */
// export const saveFacebookToken = (token: string): void => {
//   localStorage.setItem('facebookAccessToken', token);
// };

// /**
//  * Facebook Access Token-ის წაკითხვა localStorage-დან
//  */
// export const getFacebookToken = (): string | null => {
//   return localStorage.getItem('facebookAccessToken');
// };